import { type Result } from '@core/domain/utils/Result.ts';
import type { ApkUpdateManifest, AppUpdateCheckResult } from '../domain/appUpdateManifest.ts';
import type { AppUpdatePort } from '../domain/ports/AppUpdatePort.ts';

/** OTA APK update: manifest fetch, version compare, download + install intent. */
export class AppUpdateApplicationService implements AppUpdatePort {
  constructor(private readonly delegate: AppUpdatePort) {}

  resolveManifestUrl(): string | null {
    return this.delegate.resolveManifestUrl();
  }

  isNativePlatform(): boolean {
    return this.delegate.isNativePlatform();
  }

  checkForUpdate(): Promise<Result<AppUpdateCheckResult, string>> {
    return this.delegate.checkForUpdate();
  }

  getInstallPermissionStatus(): Promise<{ allowed: boolean }> {
    return this.delegate.getInstallPermissionStatus();
  }

  openInstallPermissionSettings(): Promise<void> {
    return this.delegate.openInstallPermissionSettings();
  }

  downloadAndInstall(
    manifest: ApkUpdateManifest,
    onProgress?: (loaded: number, total: number | null) => void,
  ): Promise<Result<void, string>> {
    return this.delegate.downloadAndInstall(manifest, onProgress);
  }
}
